import React, { createElement } from 'react'

// Node Modules
import { DomElement, domToReact } from 'html-react-parser'

// Components
import ExpandCollapseAll from 'components/xis/ExpandCollapseAll'

export default (node:DomElement, params:any, options:any) => {

  let attribs = node.attribs
  let content = domToReact([node]) 
  let target = attribs ? attribs['data-expandcollapse'] : null
  let aria = node.children ? node.children[0].data : ''

  // Hotfix 2.18.1: hide Expand/collapse buttons if missing full hand-shake attributes.
  let bodyContent = document.getElementsByClassName('xisCas-collapse-content')[0]
  if (bodyContent) {
    return createElement(
      ExpandCollapseAll as React.FunctionComponent, 
      { 
        target: target,
        content: content,
        sectionLabel: aria
      } as any
    ) 
  }
}